/**
 * Farlo UI | CRM
 *
 * @author Farlo
 */

// Farlo UI MC
class FarloUiMc {

	constructor(_config) {
		const _self = this;
		let _instance = null;
		this.config = {
			formId: '',
			nextBtn: '.farlo-ui-mc-next',
			prevBtn: '.farlo-ui-mc-prev',
			navContainer: '.farlo-ui-mc-nav',
			closeBtn: '.farlo-ui-mc-close',
			tabClass: '.farlo-ui-mc-tab',
			stepsClass: '.farlo-ui-mc-step',
			initData: null,
			startPage: 0,
			validateFirst: false
		};
		this.params = {
			initialised: false,
			currentStep: 0,
			totalSteps: 0,
			emailHash: '',
			data: new FormData()
		};

		this.init = (config) => {
			if (_self.params.initialised) {
				_self.toggleForm();
			}
			window._farlo.events.push('Signup', 'Started');

			if (typeof config === 'string') {
				_self.config.formId = config;
			} else if (typeof config === 'object') {
				_self.config = {
					..._self.config,
					...config
				};
			} else {
				console.log('No Form ID set');
				return false;
			}
			_instance = document.getElementById(_self.config.formId);
			_self.params.totalSteps = _instance.querySelectorAll(_self.config.stepsClass).length;
			if (_self.params.totalSteps === 1) {
				_instance.querySelector(_self.config.stepsClass).style.display = 'none';
			}

			if (_self.config.initData) {

				for (const i in _self.config.initData) {
					if (_instance.querySelector('#' + i)) {
						if (_instance.querySelector('#' + i).type === 'checkbox') {
							_instance.querySelector('#' + i).checked = _self.config.initData[ i ];
						} else {
							_instance.querySelector('#' + i).value = _self.config.initData[ i ];
						}
					}
				}
				if (_self.config.validateFirst) {
					_self.nextPrev(1);
				} else {
					_self.showPage(_self.config.startPage);
				}
			} else {
				_self.showPage(_self.config.startPage);
			}

			_self.toggleForm();

			_instance.querySelector(_self.config.nextBtn).addEventListener('click', () => {
				_self.nextPrev(1);
			});
			_instance.querySelector(_self.config.prevBtn).addEventListener('click', () => {
				_self.nextPrev(-1);
			});
			_instance.querySelectorAll(_self.config.closeBtn).forEach((btn) => {
				btn.addEventListener('click', (e) => {
					e.stopImmediatePropagation();
					_self.toggleForm();
				});
			});
			_self.params.initialised = true;
		};

		this.toggleForm = () => {
			if (_instance.style.display === 'flex') {
				_instance.style.display = 'none';
			} else {
				_instance.style.display = 'flex';
			}
		};

		this.submitData = (n, x) => {
			window._farlo.events.push('Signup', 'Stage Complete', (_self.params.currentStep + 1));
			_self.params.data.append('action', 'farlo-ui-modify-subscriber');
			_self.params.data.append('nonce', farloUiMcAjaxHandler.nonce);
			_self.params.data.append('hash', _self.params.emailHash);

			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-mc-textbox').forEach((el) => {
				if (el.value !== '') {
					_self.params.data.append('FARLO_UI_MC_' + el.id, el.value);
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-mc-hidden').forEach((el) => {
				if (el.value !== '') {
					_self.params.data.append('FARLO_UI_MC_' + el.id, el.value);
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-mc-form-item-single_checkbox').forEach((field) => {
				const el = field.querySelector('.farlo-ui-mc-input');
				if (el.checked !== '') {
					_self.params.data.append('FARLO_UI_MC_' + el.id, el.value);
				}
			});
			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-mc-form-item-single_choice_field').forEach((field) => {
				let id = field.querySelector('.farlo-ui-mc-choice').id;
				id = id.replace('farlo-ui-mc-choice-', '');
				const choices = [];
				field.querySelectorAll('.farlo-ui-mc-input').forEach((el) => {
					if (el.checked) {
						choices.push(field.querySelector("label[for='" + el.id + "']").innerText);
					}
				});
				_self.params.data.append('FARLO_UI_MC_' + id, choices.toString());
			});

			x[ _self.params.currentStep ].querySelectorAll('.farlo-ui-mc-form-item-multiple_choice_field').forEach((field) => {
				let id = field.querySelector('.farlo-ui-mc-choice').id;
				id = id.replace('farlo-ui-mc-choice-', '');
				const choices = [];
				field.querySelectorAll('.farlo-ui-mc-input').forEach((el) => {
					if (el.checked) {
						choices.push(field.querySelector("label[for='" + el.id + "']").innerText);
					}
				});
				_self.params.data.append('FARLO_UI_MC_' + id, choices.toString());
			});

			fetch(farloUiMcAjaxHandler.ajaxurl, {
				method: 'POST',
				credentials: 'same-origin',
				body: _self.params.data
			}).then((response) => response.json()).then((data) => {
				if (!data || !data.success) {
					throw new Error(`Request failed with status ${ data.detail }`);
				}
				if (data.data.email_hash) {
					_self.params.emailHash = data.data.email_hash;
				}

				x[ _self.params.currentStep ].classList.remove('loading');
				x[ _self.params.currentStep ].style.display = 'none';
				_self.params.currentStep = _self.params.currentStep + n;
				_self.showPage(_self.params.currentStep);
			});
		};

		this.showPage = (n) => {
			const tabs = _instance.querySelectorAll(_self.config.tabClass);
			console.log(tabs);
			// Hide all tabs by default
			tabs.forEach((tab) => {
				tab.style.display = 'none';
			});
		
			// Show the current tab (n)
			tabs[n].style.display = 'block';
		
			// Handle navigation buttons visibility
			if (n === 0) {
				// Hide 'Previous' on the first tab
				_instance.querySelector(_self.config.prevBtn).style.display = 'none';
			} else {
				_instance.querySelector(_self.config.prevBtn).style.display = 'inline';
			}
		
			if (n === (tabs.length - 2)) {
				// Change 'Next' to 'Submit' on the last step before completion
				_instance.querySelector(_self.config.nextBtn).innerHTML = 'Submit';
			} else {
				_instance.querySelector(_self.config.nextBtn).innerHTML = 'Next';
			}
		
			if (n === (tabs.length - 1)) {
				// Hide navigation buttons on the completion tab
				_instance.querySelector(_self.config.navContainer).style.display = 'none';
			} else {
				_instance.querySelector(_self.config.navContainer).style.display = 'flex';
			}
		
			// Update the step indicator
			_self.indicatorStep(n);
		};
		
		

		this.nextPrev = (n) => {
			const x = _instance.querySelectorAll(_self.config.tabClass);
		
			if (n === 1 && !_self.validatePage()) {
				return false; // Stop if validation fails
			}
		
			// If it's the last step, submit the form
			if (_self.params.currentStep === (x.length - 2)) {
				_self.submitData(n, x); // Submit data here
			} else {
				x[_self.params.currentStep].style.display = 'none'; // Hide current step
				_self.params.currentStep = _self.params.currentStep + n; // Increment step
				_self.showPage(_self.params.currentStep); // Show next step
			}
		};
		

		this.validatePage = () => {
			let i,
				valid = true;
			const x = _instance.querySelectorAll(_self.config.tabClass);
			const y = x[ _self.params.currentStep ].getElementsByTagName('input');
			for (i = 0; i < y.length; i ++) {
				if (y[ i ].type === 'email') {
					if (!window._farlo.helpers.validators.email(y[ i ].value)) {
						y[ i ].className += ' invalid';
						valid = false;
					}
				} else if (y[ i ].type === 'checkbox' && y[ i ].required) {
					if (!y[ i ].checked) {
						y[ i ].className += ' invalid';
						valid = false;
					}
				} else if (y[ i ].value === '' && y[ i ].required) {
					y[ i ].className += ' invalid';
					valid = false;
				}
			}
			if (valid) {
				_instance.querySelectorAll(_self.config.stepsClass)[ _self.params.currentStep ].className += ' finish';
			}
			return valid;
		};
		

		this.indicatorStep = (n) => {
			if (n < _self.params.totalSteps) {
				let i;
				const x = _instance.querySelectorAll(_self.config.stepsClass);
				for (i = 0; i < x.length; i ++) {
					x[ i ].className = x[ i ].className.replace(' active', '');
				}
				x[ n ].className += ' active';
			} else {
				window._farlo.events.push('Signup', 'Complete');
			}
		};

		_self.init(_config);
	}
}

HTMLDivElement.prototype.farloUiMc = function(settings) {
	return new FarloUiMc(this, settings);
};

